import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import type { BlogPost } from '../../../../shared/models/blog.model';
import { BLOG_COPY } from '../../constants/blog.constants';

@Component({
  selector: 'app-article-footer',
  imports: [RouterLink],
  templateUrl: './article-footer.component.html',
  styleUrl: './article-footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ArticleFooterComponent {
  post = input.required<BlogPost>();
  prevPost = input<BlogPost | null>(null);
  nextPost = input<BlogPost | null>(null);

  protected readonly copy = BLOG_COPY;
  protected copied = signal(false);
  private readonly platformId = inject(PLATFORM_ID);

  protected shareTwitter(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(document.title);
    window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank', 'noopener');
  }

  protected shareFacebook(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const url = encodeURIComponent(window.location.href);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'noopener');
  }

  protected shareWhatsApp(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(document.title);
    window.open(`https://wa.me/?text=${text}%20${url}`, '_blank', 'noopener');
  }

  protected copyUrl(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    navigator.clipboard.writeText(window.location.href).then(() => {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    });
  }
}
